import Vue from 'vue';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/de';

Vue.use(require('vue-moment'), { moment });
